import combineBenchlingReducers from 'util/combineBenchlingReducers';

import reduceBlockEditorUIs, {
  BlockEditorUIsState,
} from './analytics-queries/block-editor/reduceBlockEditorUIs';
import reduceBlockViewState, {BlockViewStates} from './analytics-queries/reduceBlockViewStates';

export interface InsightsUIState {
  blockEditorUIs: BlockEditorUIsState;
  blockViewStates: BlockViewStates;
}

export default combineBenchlingReducers({
  blockEditorUIs: reduceBlockEditorUIs,
  blockViewStates: reduceBlockViewState,
});
